/**
 *
 * @param {Event} e Evento blur
 * @param {String} nameField Nome Do Campo
 * @param {String} formName Nome do Formulario
 */
export default function handleBlurDatalayer (e, nameField, formName) {
  window.dataLayer.push({
    'event': 'form-field',
    'form': formName,
    'fieldName': nameField,
    'fieldLength': e.target.value.length,
  })
}



// WEBPACK FOOTER //
// ./src/helpers/BI/formDataLayer.js